export const articleUrlReduces = (state: string) => state || '';
